import { API } from './config-dashback.api';

export const getRegionsApi = (country: string) => API.get('/cities', { params: { country } });
